import React from "react";
import { connect } from "react-redux";
import { AgBytesAPI } from "@ai360/core";

import {
    toProductDropdownOptions,
    useLoggedInUserProductScopeOrgLevelGuid,
    useProductList,
} from "~/admin/setup/customer/use-product-list";
import { toSelectableCropDropdownOptions, useCropList } from "~/admin/setup/customer/use-crop-list";

import AddEditPanelContainer from "./../../../containers/add-edit-panel";
import AddEditPanel from "./add-edit-panel";
import { pickLists, dropdowns, unitTypes, service, PRODUCT_DROPDOWN, model } from "./../data";
import {
    testEquation,
    validateCropListToggle,
    unlinkedCropsToggle,
    unlinkedProductsToggle,
    fetchEquationParameterPickList,
} from "./../data/actions";
import { getEquationTestValue, getEquationParametersPicklist } from "./../data/selectors";

const mapStateToProps = (state) => ({
    testValue: getEquationTestValue(state),
    equationParametersPicklist: getEquationParametersPicklist(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchEquationParameterPickList: (payload) => dispatch(fetchEquationParameterPickList(payload)),
    testEquation: (payload) => dispatch(testEquation(payload)),
    validateCropListToggle: (payload) => dispatch(validateCropListToggle(payload)),
    unlinkedCropsToggle: (payload) => dispatch(unlinkedCropsToggle(payload)),
    unlinkedProductsToggle: (payload) => dispatch(unlinkedProductsToggle(payload)),
});

const ConnectedAddEditPanel = connect(
    mapStateToProps,
    mapDispatchToProps
)(
    AddEditPanelContainer(AddEditPanel, {
        pickLists,
        dropdowns,
        unitTypes,
        service,
    })
);

const AddEditContainer = (props) => {
    const orgLevelGuid = useLoggedInUserProductScopeOrgLevelGuid();
    const { products } = useProductList({
        orgLevelGuid,
        scope: AgBytesAPI.ProductSelectionListScope.UserHierarchy,
    });
    const { crops } = useCropList({ orgLevelGuid });

    return (
        <ConnectedAddEditPanel
            {...props}
            {...{
                [PRODUCT_DROPDOWN]: toProductDropdownOptions(products),
                [model.PROPS_CROP_NAME]: toSelectableCropDropdownOptions(crops),
            }}
        />
    );
};

export default AddEditContainer;
